import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../lib/auth'

export default function SessionExpiredToast() {
  const navigate = useNavigate()
  const sessionExpired = useAuthStore((s) => s.sessionExpired)
  const clearSessionExpired = useAuthStore((s) => s.clearSessionExpired)

  if (!sessionExpired) return null

  const handleLoginAgain = () => {
    clearSessionExpired()
    navigate('/login')
  }

  return (
    <div
      role="alert"
      className="fixed bottom-6 right-6 z-50 max-w-sm w-full"
    >
      <div className="bg-[#0d1321] border border-amber-500/40 rounded-xl shadow-2xl shadow-amber-900/20 p-5">
        <div className="flex items-start justify-between gap-4">
          <div className="flex items-start gap-3">
            <div className="w-8 h-8 rounded-full bg-amber-500/15 flex items-center justify-center shrink-0 mt-0.5">
              <svg className="w-4 h-4 text-amber-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                  d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
              </svg>
            </div>
            <div>
              <p className="text-white font-semibold text-sm">Session Expired</p>
              <p className="text-gray-400 text-xs mt-1 leading-relaxed">
                Your session has expired. Please log in again to continue.
              </p>
            </div>
          </div>
          <button
            onClick={() => { clearSessionExpired() }}
            className="text-gray-500 hover:text-white transition shrink-0 mt-0.5"
            aria-label="Dismiss"
          >
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <button
          onClick={handleLoginAgain}
          className="mt-4 w-full bg-amber-500 hover:bg-amber-400 text-black font-semibold text-sm py-2 rounded-lg transition"
        >
          Log In Again
        </button>
      </div>
    </div>
  )
}
